<template>
    <div>
        <popup
            v-if="$configuration.features.imageSearch"
            :opened="store.state.ui.isImageSearchVisible"
            :title="$t('imageSearch.title')"
            class="l-ss-c-search-popup-image-search-popup"
            @close="() => toggleImageSearch(false)">
            <image-search-container
                :base-image="base64Image"
                :base-image-result="(hasImageSearchResults) ? base64ImageResult : null"
                @search="onImageSearch"
                @base64-change="onFileBase64Change"
                @crop-change="onCropChange"
                @image-search-button-select-file-click="value => $emit('image-search-button-select-file-click', value)"
                @image-search-use-correct-link-click="value => $emit('image-search-use-correct-link-click', value)"
                @image-search-use-incorrect-link-click="value => $emit('image-search-use-incorrect-link-click', value)"
                @image-search-button-search-click="value => $emit('image-search-button-search-click', value)"/>
        </popup>
    </div>
</template>
<script>
    import ImageSearchContainer from '../core/components/image-search-container';
    import RootComponentMixin from '../core/mixins/root-component';
    import Popup from '../core/components/popup';

    export default {
        components: {
            ImageSearchContainer,
            Popup,
        },
        props: {
            ...RootComponentMixin.props,
        },
        data() {
            return {
                base64Image: null,
                base64ImageResult: null,
                isBase64ImageChanged: false,
                sectionImageKey: '',
            };
        },

        computed: {
            ...RootComponentMixin.computed,
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
        },

        watch: {
            'searchState.public': function (state) {
                this.base64ImageResult = null;
                this.base64Image = null;
            },
            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
            'store.state.ui.isImageSearchVisible': {
                handler(value) {
                    if (value) {
                        this.setPosition();
                    } else {
                        this.resetPosition();
                    }
                },
            },
            base64Image() {
                this.isBase64ImageChanged = true;
            },
        },

        mounted() {
            this.$on('search-input-change', () => {
                this.base64Image = null;
                this.base64ImageResult = null;
            });
            this.$on('handle-search', () => {
                this.base64Image = null;
                this.base64ImageResult = null;
            });
        },

        methods: {
            ...RootComponentMixin.methods,
            onFileBase64Change(base64Image) {
                this.base64Image = base64Image;
                this.store.commit('base64Image/SET_PROPERTY', this.base64Image);
            },
            onCropChange(event) {
                this.base64ImageResult = event.canvas.toDataURL('image/jpeg');
            },
            onImageSearch() {
                // This.store.commit('base64ImageResult/SET_PROPERTY', this.base64ImageResult);
                this.$emit('search-image', { base64: this.base64ImageResult });
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            setPosition() {
                this.$wrapper = document.querySelector('.l-ss-c-host-wrapper-is-image-search');
                this.$wrapper.style.display = 'flex';
                this.bodyClient = document.body;
                this.bodyClient.style.overflow = 'hidden';
            },
            resetPosition() {
                this.$wrapper.style.display = 'none';
                this.bodyClient.style.overflow = 'auto';
            },
        },
    };
</script>